import { render, staticRenderFns } from "./shop-item-field.vue?vue&type=template&id=af66ce60&scoped=true&"
import script from "./shop-item-field.vue?vue&type=script&lang=js&"
export * from "./shop-item-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af66ce60",
  null
  
)

export default component.exports